import script from "./ProductDetailTableWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailTableWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailTableWrapper.vue?vue&type=style&index=0&id=6f6bd80c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6bd80c"]])

export default __exports__